export default __webpack_public_path__ + "static/media/ic-classic-save.e7b63970.svg";